import { produce } from 'immer';
import { writable } from 'svelte/store';

let innerStore = {
  tableData: [],
  repeatRows: [[]],
  repeatTimesPerRow: [],
  width: 0,
  yarns: [],
  hasInitialized: false,
};

let store = writable(innerStore);

function update(func) {
  let data = produce(snapshot, func);
  store.set(data);
}

let snapshot;
store.subscribe((value) => {
  snapshot = value;
});

export default {
  update,
  subscribe: function (subscription) {
    return store.subscribe(subscription);
  },
  insertColumn: function (index) {
    this.table.insertColumn(index);
  },
  table: {
    setValue: function (column, row, value) {
      update((temp) => {
        for (let i = 0; i < temp.tableData.length; i++) {
          temp.tableData[i][column] = undefined;
        }
        temp.tableData[row][column] = value;
        temp.tableData = [...temp.tableData];
      });
    },
    insertColumn: function (index) {
      update((temp) => {
        for (let row of temp.tableData) {
          row.splice(index + 1, 0, undefined);
        }
        temp.width++;
      });
    },
    deleteRow: function (row) {
      update((temp) => {
        temp.tableData = temp.tableData.filter((v, i) => i !== row);
      });
    },
    addYarn: function (yarn) {
      update((temp) => {
        temp.yarns.push(yarn);
        temp.tableData.push([]);
      });
    },
    removeColumn: function (column) {
      update((temp) => {
        temp.tableData.forEach((row) => row.splice(column, 1));
        temp.width--;
      });
    },
    toThreads: function () {
      let data = snapshot.tableData;
      let yarns = snapshot.yarns;

      let threads = [];
      if (data !== undefined && data.length > 0) {
        for (let i = 0; i < data[0].length; i++) {
          for (let j = 0; j < data.length; j++) {
            if (data[j][i] !== undefined && threads[i] === undefined) {
              threads[i] = { yarn: yarns[j], times: data[j][i] };
            }
          }
        }
      }
      return threads;
    },
  },
  repeats: {
    setRepeatRows: function (repeatRows) {
      update((temp) => {
        temp.repeatRows = repeatRows;
      });
    },
    setRepeatTimesPerRow: function (repeatTimesPerRow) {
      update((temp) => {
        temp.repeatTimesPerRow = repeatTimesPerRow;
      });
    },
  },
  initialize: (yarns) => {
    if (!snapshot.hasInitialized) {
      store.update((pre) => {
        return {
          ...pre,
          hasInitialized: true,
          yarns: yarns.map((y) => y.id),
          tableData: Array(yarns.length).fill([]),
        };
      });
    }
  },
};
